import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './features/auth/AuthContext';
import { LoginPage } from './features/auth/LoginPage';
import { InvitationPage } from './features/auth/InvitationPage';
import { ForgotPasswordPage } from './features/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './features/auth/ResetPasswordPage';
import { ProjectsPage } from './features/projects/ProjectsPage';

// Deliberately flat: the whole hub is one screen (list + drill-in drawer),
// not a route jungle. Only the unauthenticated auth flows have their own
// routes (they need shareable invitation / reset links).
function AppGate() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-black/50">Laster prosjekthub…</div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/invitasjon/:token" element={<InvitationPage />} />
        <Route path="/glemt-passord" element={<ForgotPasswordPage />} />
        <Route path="/tilbakestill-passord/:token" element={<ResetPasswordPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="*" element={<ProjectsPage />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppGate />
      </AuthProvider>
    </Router>
  );
}

export default App;
